// A small green dot: the teammate's app session sent a recent presence heartbeat (OP-011).
// It says nothing about server, database or provider health.
// Render inside a `relative` parent (e.g. an avatar) to overlay on the corner.
export const PRESENCE_LABEL = "Présent dans l’application (signal de présence récent)";
export const PRESENCE_SCOPE = "Présence applicative : un onglet ouvert a envoyé un signal récent. Ce n’est pas un indicateur de santé du serveur ni des fournisseurs (Apify, YouTube).";

export function PresenceDot({ online, testid, className = "" }) {
  if (!online) return null;
  return (
    <span
      data-testid={testid}
      title={PRESENCE_LABEL}
      aria-label={PRESENCE_LABEL}
      className={`absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-[hsl(var(--emerald))] ring-2 ring-background ${className}`}
    />
  );
}

export default PresenceDot;
